import { useTranslation } from 'react-i18next';

export default function HowWeWork() {
  const { t } = useTranslation();

  const steps = [
    { number: t('howWeWork.s1.number'), title: t('howWeWork.s1.title'), desc: t('howWeWork.s1.desc') },
    { number: t('howWeWork.s2.number'), title: t('howWeWork.s2.title'), desc: t('howWeWork.s2.desc') },
    { number: t('howWeWork.s3.number'), title: t('howWeWork.s3.title'), desc: t('howWeWork.s3.desc') },
    { number: t('howWeWork.s4.number'), title: t('howWeWork.s4.title'), desc: t('howWeWork.s4.desc') },
  ];

  return (
    <section className="py-24" style={{ backgroundColor: '#F8F9FB' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-3 block">{t('howWeWork.badge')}</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('howWeWork.title')}
          </h2>
          <p className="text-sm text-gray-500 max-w-lg mx-auto">
            {t('howWeWork.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gray-200 mx-[10%]"></div>

          {steps.map((step, index) => (
            <div key={step.number} className="relative flex flex-col items-center text-center">
              <div
                className={`w-20 h-20 rounded-full flex items-center justify-center z-10 mb-6 border-2 ${
                  index === 0 ? 'bg-blue-600 border-blue-600' : 'bg-white border-gray-200'
                }`}
              >
                <span
                  className={`text-xl font-bold ${index === 0 ? 'text-white' : 'text-blue-600'}`}
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {step.number}
                </span>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
